import { Show } from '@elfsight/lib-utils';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { Portal, PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  useFontsLoader
} from '@elfsight/widget-ui';
import { StorageProvider } from '@elfsight/widget-utils';
import { positions } from './constants';
import { meta } from './meta';
import type { ClickToCallSettings } from './types';
import { Widget } from './widget/Widget';

const { alias } = meta;

export function ClickToCall({
  widgetId = '',
  customCSS,
  customJS,
  editMode,
  font,
  renderThumbnailMode,
  position: positionSetting
}: ClickToCallSettings) {
  const { position } = positions[positionSetting];
  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    alias,
    widgetId
  );

  useDefineAPISchema();
  useFontsLoader([font]);
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <StorageProvider name={alias} widgetId={widgetId ?? ''}>
      <Show when={position === 'embed'}>
        <EmbedRoot
          customCSSClassName={customCSSPrefixClassName}
          fullWidth={false}
          font={font}
        >
          <Widget />
        </EmbedRoot>
      </Show>

      <Show when={position !== 'embed'}>
        <PortalNestProvider
          customCSSClassName={customCSSPrefixClassName}
          font={font}
        >
          <Portal>
            <Widget />
          </Portal>
        </PortalNestProvider>
      </Show>

      <CustomCSS
        customCSS={customCSS}
        prefixClassName={customCSSPrefixClassName}
      />
    </StorageProvider>
  );
}
